function PrivacyPolicy() {
    return (
        <div className="mx-auto w-11/12 md:w-4/5">
            <p>Date de dernière mise à jour : 15.05.2025</p>

            <h2 className="text-xl md:text-2xl font-bold mt-4 mb-2">1. Introduction</h2>

            <p>
                Le site <a className="text-primary-light hover:underline" href="https://foti-immo.ch">https://foti-immo.ch</a> (ci-après "le Site")
                est exploité par FOTI Immobilier Sàrl, et s'engage à
                protéger la vie privée de ses utilisateurs conformément à la législation en vigueur, notamment le
                Règlement Général sur la Protection des Données (RGPD).
            </p>

            <h2 className="text-xl md:text-2xl font-bold mt-4 mb-2">2. Données collectées</h2>

            <h3 className="text-lg md:text-xl">Par le formulaire de contact :</h3>
            <ul className="list-disc pl-4">
                <li>Nom</li>
                <li>Prénom</li>
                <li>Adresse e-mail</li>
                <li>Numéro de téléphone</li>
                <li>Adresse postale complète</li>
                <li>Message</li>
            </ul>

            <h3 className="text-lg md:text-xl"> Par le formulaire d’estimation immobilière :</h3>
            <ul className="list-disc pl-4">
                <li>Type de bien</li>
                <li>Surface habitable</li>
                <li>Surface de terrain</li>
                <li>Nombre de pièces</li>
                <li>Nombre de salles de bain</li>
                <li>Année de construction</li>
                <li>État du bien</li>
                <li>Présence d’un garage ou d’une place de parking</li>
                <li>Autres caractéristiques</li>
                <li>Adresse du bien</li>
                <li>Informations de contact (comme ci-dessus)</li>
                <li>Motif de la demande d’estimation</li>
            </ul>

            <h2 className="text-xl md:text-2xl font-bold mt-4 mb-2">3. Finalité de la collecte</h2>
            Les données sont collectées uniquement pour :
            <ul className="list-disc pl-4">
                <li>Répondre aux demandes envoyées via le formulaire de contact.</li>
                <li>Réaliser une estimation immobilière demandée par l'utilisateur.</li>
                <li>Contacter l'utilisateur si nécessaire dans le cadre de sa demande.</li>
            </ul>

            <h2 className="text-xl md:text-2xl font-bold mt-4 mb-2">4. Stockage et sécurité</h2>

            <p>
                Les données ne sont <span className="font-bold">pas stockées sur le Site</span> mais transmises par
                e-mail au courtier en charge, et
                conservées uniquement dans sa boîte mail.
            </p>

            <h2 className="text-xl md:text-2xl font-bold mt-4 mb-2">5. Partage des données</h2>
            <p>
                Les données ne sont pas transmises à des tiers sans consentement explicite, sauf obligation légale.
            </p>

            <h2 className="text-xl md:text-2xl font-bold mt-4 mb-2">6. Droits des utilisateurs</h2>

            Conformément au RGPD, les utilisateurs disposent des droits suivants :
            <ul className="list-disc pl-4">
                <li>Droit d’accès à leurs données personnelles</li>
                <li>Droit de rectification</li>
                <li>Droit à l’effacement</li>
                <li>Droit d’opposition et de limitation du traitement</li>
            </ul>

            Pour exercer ces droits, contactez : <a className="text-primary-light hover:underline" href="mailto:info@foti-immo.ch">info@foti-immo.ch</a>.

            <h2 className="text-xl md:text-2xl font-bold mt-4 mb-2">7. Contact</h2>

            Pour toute question relative à la politique de confidentialité :
            <p>FOTI Immobilier Sàrl</p>
            <p>Rue de Venise 8, 1870 Monthey, Suisse</p>
            <p>
                <a className="text-primary-light hover:underline" href="mailto:info@foti-immo.ch">info@foti-immo.ch</a>
            </p>

        </div>
    );
}

export default PrivacyPolicy;